/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function ProfileDocuments({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="78.5"
        cy="78.5"
        r="77.5"
        fill={mainColor}
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M53.5 119.333H103.5C107.636 119.333 111 115.969 111 111.833V59H93.5C89.3643 59 86 55.6357 86 51.5V34H53.5C49.3643 34 46 37.3643 46 41.5V111.833C46 115.969 49.3643 119.333 53.5 119.333ZM63.5 69.1667H93.5C94.8818 69.1667 96 70.2848 96 71.6667C96 73.0485 94.8818 74.1667 93.5 74.1667H63.5C62.1182 74.1667 61 73.0485 61 71.6667C61 70.2848 62.1182 69.1667 63.5 69.1667ZM63.5 79.1667H93.5C94.8818 79.1667 96 80.2848 96 81.6667C96 83.0485 94.8818 84.1667 93.5 84.1667H63.5C62.1182 84.1667 61 83.0485 61 81.6667C61 80.2848 62.1182 79.1667 63.5 79.1667ZM63.5 89.1667H93.5C94.8818 89.1667 96 90.2848 96 91.6667C96 93.0485 94.8818 94.1667 93.5 94.1667H63.5C62.1182 94.1667 61 93.0485 61 91.6667C61 90.2848 62.1182 89.1667 63.5 89.1667ZM63.5 99.1667H83.5C84.8818 99.1667 86 100.285 86 101.667C86 103.048 84.8818 104.167 83.5 104.167H63.5C62.1182 104.167 61 103.048 61 101.667C61 100.285 62.1182 99.1667 63.5 99.1667Z"
        fill={secondaryColor}
      />
      <path
        d="M93.499 53.9951H109.534L90.999 35.46V51.4951C90.999 52.8745 92.1197 53.9951 93.499 53.9951Z"
        fill={secondaryColor}
      />
    </svg>
  );
}
ProfileDocuments.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
ProfileDocuments.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(ProfileDocuments);
memoized.displayName = 'ProfileDocuments';
export default memoized;
